const DEFAULT_FRACTION_DIGITS = 6;

export const convertToPercentage = (value: number, fractionDigits = DEFAULT_FRACTION_DIGITS): number =>
  Number((value * 100).toFixed(fractionDigits));
